import { render, staticRenderFns } from "./ExternalOrderOverview.component.vue?vue&type=template&id=13a4e628&scoped=true&"
import script from "./ExternalOrderOverview.component.vue?vue&type=script&lang=js&"
export * from "./ExternalOrderOverview.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a4e628",
  null
  
)

export default component.exports